<template>
	<div class="h-screen flex w-full bg-img" id="recuperar-senha">
		<transition name="fade" appear>
			<div
				class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center"
			>
				<vx-card>
					<div slot="no-body" class="full-page-bg-color">
						<div class="vx-row m-0">
							<div
								class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
							>
								<img
									src="@/assets/images/views/senha/forgot-password.png"
									alt="Imagem recuperar senha"
									class="mx-auto"
								/>
							</div>
							<div
								id="content-recuperar-senha"
								class="relative vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
							>
								<div class="p-8">
									<div class="vx-card__title mb-10">
										<h4 class="mb-4">Recuperar senha</h4>
										<p>
											Digite seu e-mail e enviaremos
											instruções sobre como redefinir sua
											senha.
										</p>
									</div>

									<form
										id="form-recuperar-senha"
										novalidate
										@submit.prevent="recuperarSenha"
									>
										<vs-input
											type="text"
											name="cpf"
											label="CPF"
											v-mask="'###.###.###-##'"
											v-model="cpf"
											class="w-full mb-4"
										/>

										<vs-input
											type="email"
											name="email"
											label="Email"
											v-model="email"
											class="w-full mb-8"
										/>

										<ld-button
											type="border"
											to="/acessar"
											class="px-4 w-full md:w-auto"
											>Voltar ao início</ld-button
										>

										<ld-button
											buttonType="submit"
											class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
											>Recuperar senha</ld-button
										>
									</form>
								</div>
							</div>
						</div>
					</div>
				</vx-card>
			</div>
		</transition>
	</div>
</template>

<script>
import Autenticacao from "../../../models/Autenticacao";
import ErrorHelper from "../../../helpers/ErrorHelper";

export default {
	name: "RecuperarSenha",
	data() {
		return {
			cpf: null,
			email: null
		};
	},
	methods: {
		async recuperarSenha() {
			const loadingRecuperarSenha = this.$vsloading({
				container: "#content-recuperar-senha",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				await Autenticacao.recuperarSenha(this.cpf, this.email);

				this.$vs.notify({
					title: "Solicitação enviada",
					text:
						"Se demorar a receber o email, cheque sua caixa de spams.",
					color: "success",
					position: "bottom-right",
					fixed: true,
					iconPack: "feather",
					icon: "icon-mail"
				});

				this.email = null;
				this.cpf = null;
			} catch (error) {
				ErrorHelper.renderFormError("#form-recuperar-senha", error);
			} finally {
				loadingRecuperarSenha.hide();
			}
		}
	}
};
</script>

<style lang="scss" scoped src="./recuperar_senha.scss"></style>
